export default __webpack_public_path__ + "static/media/discount_white.c08af6b0.svg";